// removed by extract-text-webpack-plugin
module.exports = {"root":"_2vRvAwQ","container":"XwNHInt","title":"IgBFNYt","link":"_6wtm-YG","secondary":"_3q6cIGK","primary":"_3mgBjhL","chevron":"ZY1FymB","chevronSvg":"ahzxV4I","image":"_33HhqsN","imageSvg":"_1hifq7u"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/LoggedInBanner/LoggedInBanner.less
 ** module id = 786
 ** module chunks = 0
 **/